import { Component, OnInit } from '@angular/core';
import { Ad } from '../../models/ad';
import { AdService } from 'src/app/services/ad.service';
import {MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ["./ads.component.scss"],
})
export class AdsComponent implements OnInit {

  public ads: Ad[] = [];

  constructor(
    private adService: AdService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.adService.getAds().subscribe(
      (adList) => { this.ads = adList },
      (err) => this.showErrorMessage(err)
    )
  }

  private showErrorMessage(err) {
    // in the future it can display error messages sent from backend
    this.snackBar.open("Ads are currently unavailable. Please try again later.", "Close", { duration: 5000 })
  }
}
